import type { DeviceType } from '@/hooks/device_type';
import { createColumnHelper } from '../appTable';

const columnHelper = createColumnHelper<DeviceType>();

export const deviceTypeTableColumns = columnHelper.columns([
  columnHelper.accessor('vendor', {
    header: 'Vendor',
    meta: { filterVariant: { type: 'singleSearch' } },
  }),
  columnHelper.accessor('model', {
    header: 'Model',
    size: 160,
    minSize: 96,
    meta: { filterVariant: { type: 'singleSearch' } },
  }),
  columnHelper.accessor('architecture', {
    header: 'Architecture',
    size: 120,
    minSize: 96,
    meta: {
      filterVariant: {
        type: 'singleSelect',
        options: [
          { name: 'x86_64', filterValue: 'x86_64' },
          { name: 'aarch64', filterValue: 'aarch64' },
        ],
      },
    },
  }),
  columnHelper.accessor('deviceCount', {
    header: 'Devices',
    size: 96,
    minSize: 80,
  }),
  columnHelper.accessor('gpu', {
    header: 'GPU',
    cell: ({ getValue }) => getValue() ?? '—',
    meta: { filterVariant: { type: 'singleSearch' } },
  }),
  columnHelper.accessor('supportedEmmaOsVersions', {
    header: 'Supported EMMA OS Versions',
    size: 340,
    minSize: 260,
    cell: ({ getValue }) => getValue() ?? '—',
    meta: { filterVariant: { type: 'singleSearch' } },
  }),
]);
